<template>

  <div>
    <div v-if="list.length > 4">
      <input 
        type="text" 
        class="form-control input-search" 
        v-model="keyword" 
        :placeholder="$t('Find')">
    </div>
    <div
      ref="list"
      class="list-group list-group-flush">
      <a
        href="javascript:void(0)"
        class="list-group-item list-group-item-action" 
        v-for="(item, index) in listFiltered" 
        @click="toggleItem(item.key)">
          <span class="checked" :class="{'active': isSelected(item.key)}"></span>
          {{ item.name }}
        </a>
    </div>
    <div
      v-if="listFiltered.length >= 4"
      class="scroll-nav">
      <a
        class="btn btn-light btn-sm"
        href="javascript:void(0)"
        @mousedown.stop="scrollUp">
        <i class="fas fa-chevron-up" />
        </a>
      <a
        class="btn btn-light btn-sm" 
        href="javascript:void(0)" 
        @mousedown.stop="scrollDown">
        <i class="fas fa-chevron-down" />
        </a>
    </div>
  </div>

</template>

<script>
export default {
  name: 'FiltersList',
  components: {
  },
  props: [
    'value',
    'list'
  ],
  data () {
    return {
      keyword: ''
    }
  },
  computed: {
    listFiltered () {
      return this.list.filter((value) => {
        return this.keyword
        ? value['name'].toLowerCase().search(this.keyword.toLowerCase()) >= 0
        : true
      })
    },
    selected () {
      if (this.value) return typeof (this.value) === 'string' ? [this.value] : this.value
      else return []
    }
  },
  created () {
  },
  methods: {
    scrollUp () {
      const height = this.$refs.list.clientHeight
      const scroll = this.$refs.list.scrollTop - height
      $(this.$refs.list).stop().animate({scrollTop: scroll}, 300, 'swing')
    },
    scrollDown () {
      const height = this.$refs.list.clientHeight
      const scroll = this.$refs.list.scrollTop + height
      $(this.$refs.list).stop().animate({scrollTop: scroll}, 300, 'swing')
    },
    /*
    toggleItem
    */
    toggleItem (value) {
      const newValue = this.$clone(this.selected)
      const index = newValue.indexOf(value)

      if (index >= 0) newValue.splice(index, 1) // remove
      else newValue.push(value) // add

      this.$emit('input', newValue)
    },
    /*
    isActive
    */
    isSelected (value) {
      return this.selected.includes(value)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.input-search {
  border: 1px solid #dfdfdf;
}
  .input-search:focus {
    border: 1px solid #dfdfdf;
    box-shadow: none;
    outline: 0 none;
  }

/*scroll-nav*/
.scroll-nav {
  display: flex;
}
  .scroll-nav > * {
    flex: 1 10px;
  }

/* list-group */
.list-group{
  max-height: 158px;
  overflow: hidden;
}
  .list-group > *{
    padding: .65rem 0; 
    background: transparent;
    border-top: 0;
    border-bottom: 1px solid #dfdfdf;
  }
  .list-group > * .checked{
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background: #e5e5e5;
    display: inline-block;
    margin: 0 3px 0 0; 
  }
  .list-group > * .checked.active {
    background: #007bff;
  }
</style>



// WEBPACK FOOTER //
// src/components/Filterfy/FiltersList.vue